var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2631_19183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.870331 19.0675C0.870331 20.7022 1.71408 21.546 3.32625 21.546H10.3776C11.9898 21.546 12.8335 20.6947 12.8335 19.0675V17.6738H14.1142C15.7264 17.6738 16.5701 16.8225 16.5701 15.1952V9.23626C16.5701 8.24184 16.3592 7.60903 15.764 6.99881L12.0124 3.17181C11.4398 2.59173 10.7618 2.36572 9.89544 2.36572H7.06285C5.45069 2.36572 4.60694 3.21701 4.60694 4.85177V6.23793H3.32625C1.71408 6.23793 0.870331 7.09675 0.870331 8.72398V19.0675ZM12.0726 11.1422L7.98947 6.99881C7.41693 6.41874 6.92725 6.26053 6.1061 6.24547V4.94217C6.1061 4.25663 6.46771 3.87242 7.19092 3.87242H10.3324V7.45082C10.3324 8.38497 10.8296 8.87465 11.7562 8.87465H15.0634V15.0973C15.0634 15.7904 14.7018 16.1746 13.9786 16.1746H12.8335V13.2817C12.8335 12.2647 12.7054 11.7901 12.0726 11.1422ZM11.5754 7.26249V4.48263L14.6717 7.63163H11.9445C11.6809 7.63163 11.5754 7.52616 11.5754 7.26249ZM2.36949 18.9695V8.82192C2.36949 8.12884 2.7311 7.74463 3.46185 7.74463H5.75956V11.8428C5.75956 12.9352 6.29444 13.4625 7.37926 13.4625H11.3343V18.9695C11.3343 19.6626 10.9727 20.0468 10.242 20.0468H3.45432C2.7311 20.0468 2.36949 19.6626 2.36949 18.9695ZM7.5224 12.1442C7.21352 12.1442 7.07792 12.0161 7.07792 11.6997V8.0309L11.1309 12.1442H7.5224Z",
    fill: "#043293"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2631_19183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "translate(0.360107 0.629883)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.576643c17b347f5e04a55ef510a17e2a.svg";
export { ForwardRef as ReactComponent };